/* Nutraviva PDP — buy box behaviour.
   Owns: gallery dots, variant switching, quantity tiers, selling plans,
   sticky bar sync. No dependencies. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.nvReady === 'true') return;
    root.dataset.nvReady = 'true';

    var data = JSON.parse(root.querySelector('[data-nv-data]').textContent);
    var form = root.querySelector('[data-nv-form]');
    var idInput = root.querySelector('[data-nv-variant-id]');
    var qtyInput = root.querySelector('[data-nv-qty-input]');
    var planInput = root.querySelector('[data-nv-plan-input]');

    var state = {
      variant: data.variants.find(function (v) { return v.id === data.selected; }) || data.variants[0],
      qty: 1,
      plan: data.defaultPlan || null
    };

    function money(cents) {
      var s = (cents / 100).toFixed(2);
      return data.currencySymbol + s;
    }

    /* Tiers are THRESHOLDS, not exact quantities: the discount app applies the
       best level whose quantity the shopper has reached, so buying 3 against a
       "2 or more" level still saves. Matching the quantity exactly showed full
       price at 3, 4, 6 and 7 while checkout charged less. */
    function tierFor(qty) {
      var match = null;
      data.tiers.forEach(function (t) {
        if (t.qty <= qty && (!match || t.qty > match.qty)) match = t;
      });
      return match || { qty: qty, off: 0 };
    }

    function lineTotal(qty) {
      var t = tierFor(qty);
      var gross = state.variant.price * qty;
      return Math.round(gross * (1 - t.off / 100));
    }

    function planTotal(qty) {
      var planId = state.plan || data.defaultPlan;
      var allocation = (state.variant.sellingPlans || []).find(function (p) {
        return String(p.id) === String(planId);
      });
      // Shopify rounds the selling-plan price per unit. One-time volume
      // discounts do not apply to subscriptions, including during asset rollout.
      var unitPrice = allocation ? allocation.price
        : Math.round(state.variant.price * (1 - data.planDiscount / 100));
      return unitPrice * qty;
    }

    function setText(sel, value) {
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }

    /* Serves and price per serve are properties of the SELECTION, not of the

       variant. Substituting the variant's own figures left both frozen at the

       single-pack numbers, so three tubs still read 80 serves and a tier

       discount never reached the per-serve line. Derive both from the chosen

       quantity and the real line total instead. */

    function totalServes(v, qty) {

      var n = parseFloat(v.serves);

      if (!isFinite(n) || n <= 0) return null;

      return n * qty;

    }


    /* Cents per serve for one pack, ignoring quantity and selling plan, so two
       variants are always compared on the same basis. Serves arrive as a string
       from the metafield, hence the Number(). Zero means we cannot compare. */
    function perServeValue(v) {
      var serves = Number(v && v.serves) || 0;
      var price = Number(v && v.price) || 0;
      if (!serves || !price) return 0;
      return price / serves;
    }

    function perServeFor(v, qty) {

      var serves = totalServes(v, qty);

      if (!serves) return v.perServe;

      var total = state.plan ? planTotal(qty) : lineTotal(qty);

      return money(Math.round(total / serves));

    }


    function token(str, v, qty) {
      return String(str || '')
        .replace(/\[serves\]/g, totalServes(v, qty) || v.serves)
        .replace(/\[per_serve\]/g, perServeFor(v, qty))
        .replace(/\[cadence\]/g, v.cadence || data.cadenceDays || '')
        .replace(/\[pct\]/g, data.planDiscount == null ? '' : data.planDiscount)
        .replace(/\[serve_size\]/g, data.serveSize || '')
        .replace(/\[variant\]/g, v.title)
        .replace(/\[qty\]/g, qty)
        .replace(/\[price\]/g, money(state.plan ? planTotal(qty) : lineTotal(qty)));
    }

    function render() {
      var v = state.variant;

      setText('[data-nv-price]', money(state.plan ? planTotal(state.qty) : lineTotal(state.qty)));

      /* Per-serve value against the least economical pack in the range. Computed
         from price and serves rather than the display metafield, so it tracks a
         price change automatically. Hidden on the baseline pack itself, on a
         single-size product, and wherever serves are missing. */
      root.querySelectorAll('[data-nv-value]').forEach(function (el) {
        var mine = perServeValue(v);
        var worst = 0;
        var worstName = '';
        data.variants.forEach(function (o) {
          var ps = perServeValue(o);
          if (ps > worst) { worst = ps; worstName = o.title; }
        });
        var pct = worst > 0 && mine > 0 ? Math.round((1 - mine / worst) * 100) : 0;
        if (pct >= 5) {
          el.textContent = pct + '% cheaper per serve than the ' + worstName;
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });

      /* Was-price scales with quantity the same way the price does, so the pair
         always describes the same basket. A variant with no genuine saving sends
         compareAt 0 and the element is hidden outright rather than left empty. */
      root.querySelectorAll('[data-nv-was]').forEach(function (el) {
        var was = Number(v.compareAt) || 0;
        if (was > 0) {
          el.textContent = money(was * state.qty);
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });

      setText('[data-nv-serves]', totalServes(v, state.qty) || v.serves);
      setText('[data-nv-per-serve]', perServeFor(v, state.qty));
      setText('[data-nv-per-serve-line]', token(data.perServeLine, v, state.qty));
      setText('[data-nv-cadence]', v.cadence || data.cadenceDays || '');

      root.querySelectorAll('[data-nv-tpl]').forEach(function (el) {
        el.textContent = token(el.dataset.nvTpl, v, state.qty);
      });

      root.querySelectorAll('[data-nv-variant]').forEach(function (btn) {
        var on = Number(btn.dataset.nvVariant) === v.id;
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      root.querySelectorAll('[data-nv-tier]').forEach(function (btn) {
        var q = Number(btn.dataset.nvTier);
        btn.setAttribute('aria-checked', q === state.qty ? 'true' : 'false');
        var out = btn.querySelector('[data-nv-tier-total]');
        if (out) out.textContent = money(lineTotal(q));
      });

      root.querySelectorAll('[data-nv-plan]').forEach(function (btn) {
        var val = btn.dataset.nvPlan || '';
        btn.setAttribute('aria-checked', String(state.plan || '') === val ? 'true' : 'false');
      });

      setText('[data-nv-plan-price]', money(planTotal(state.qty)));
      setText('[data-nv-once-price]', money(lineTotal(state.qty)));

      setText('[data-nv-sticky-name]', data.productTitle + ' ' + v.title);
      /* Same guard for the sticky bar: drop the per-serve clause rather than
         printing a dangling separator after the price. */
      var subLine = data.stickySubLine || '';
      if (subLine.indexOf('[per_serve]') !== -1 && !perServeFor(v, state.qty)) {
        subLine = subLine.split('[per_serve]')[0].replace(/[\s\u00b7|,-]+$/, '');
      }
      setText('[data-nv-sticky-sub]', token(subLine, v, state.qty));
      setText('[data-nv-step-out]', state.qty);

      if (idInput) idInput.value = v.id;
      if (qtyInput) qtyInput.value = state.qty;
      if (planInput) planInput.value = state.plan || '';

      root.querySelectorAll('[data-nv-cta], [data-nv-cta-sticky]').forEach(function (btn) {
        btn.disabled = !v.available;
        var full = btn.hasAttribute('data-nv-cta-sticky') ? data.stickyCtaLabel : data.ctaLabel;
        full = token(full, v, state.qty);
        /* The suffix is appended here rather than baked into the label, so the
           server-rendered button never ships raw [price] tokens that would flash
           before this runs, or stick if the script fails.
           It is only appended when it will actually resolve: a product with no
           serves data would otherwise render the separator on its own, as in
           "Add to cart \u00b7  per serve". */
        if (data.ctaSuffix && !btn.hasAttribute('data-nv-cta-sticky')) {
          var wantsPerServe = data.ctaSuffix.indexOf('[per_serve]') !== -1;
          if (!wantsPerServe || perServeFor(v, state.qty)) {
            full += ' ' + token(data.ctaSuffix, v, state.qty);
          }
        }
        btn.textContent = v.available ? full : data.soldOutLabel;
      });

      if (history.replaceState && v.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('click', function (e) {
      var vBtn = e.target.closest('[data-nv-variant]');
      if (vBtn) {
        var found = data.variants.find(function (x) { return x.id === Number(vBtn.dataset.nvVariant); });
        if (found) {
          state.variant = found;
          render();
          /* Move the gallery to this size's own pack shot, so a Black Label or a
             100g selection does not leave the previous size on screen. */
          if (typeof found.mediaIndex === 'number' && found.mediaIndex >= 0) {
            goToSlide(found.mediaIndex);
          }
        }
        return;
      }
      var tBtn = e.target.closest('[data-nv-tier]');
      if (tBtn) { state.qty = Number(tBtn.dataset.nvTier); render(); return; }

      var pBtn = e.target.closest('[data-nv-plan]');
      if (pBtn) { state.plan = pBtn.dataset.nvPlan || null; render(); return; }

      var up = e.target.closest('[data-nv-step-up]');
      if (up) { state.qty = Math.min(data.maxQty, state.qty + 1); render(); return; }

      var down = e.target.closest('[data-nv-step-down]');
      if (down) { state.qty = Math.max(1, state.qty - 1); render(); return; }

      var dot = e.target.closest('[data-nv-dot]');
      if (dot) { goToSlide(Number(dot.dataset.nvDot)); return; }

      var thumb = e.target.closest('[data-nv-thumb]');
      if (thumb) { goToSlide(Number(thumb.dataset.nvThumb)); }
    });

    function goToSlide(i, behavior) {
      var strip = root.querySelector('[data-nv-gallery]');
      if (!strip) return;
      /* Scroll to the slide's own offset rather than i * clientWidth: the strip
         carries an 8px gap between slides, so the multiplied figure drifts one
         gap further out of line on every step and lands short on the last one. */
      var slide = strip.children[i];
      var left = slide ? slide.offsetLeft - strip.offsetLeft : i * strip.clientWidth;
      strip.scrollTo({ left: left, behavior: behavior || 'smooth' });
      markSlide(i);
    }

    function markSlide(i) {
      root.querySelectorAll('[data-nv-dot]').forEach(function (d) {
        d.setAttribute('aria-current', Number(d.dataset.nvDot) === i ? 'true' : 'false');
      });
      root.querySelectorAll('[data-nv-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', Number(t.dataset.nvThumb) === i ? 'true' : 'false');
      });
    }

    var gallery = root.querySelector('[data-nv-gallery]');
    if (gallery) {
      var raf;
      gallery.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          markSlide(Math.round(gallery.scrollLeft / gallery.clientWidth));
        });
      }, { passive: true });
    }

    /* Add to cart without leaving the PDP.
       The form was a plain {% form 'product' %} submit, so the browser POSTed
       and Shopify answered with a redirect to /cart. Post to /cart/add.js
       instead and hand the response to the theme's cart drawer.
       The section ids come from the drawer itself, exactly as the theme's own
       product-form.js does: Dawn's renderContents() iterates
       getSectionsToRender() and throws on any id missing from the response, so
       requesting a short list fails and falls through to a /cart redirect. */
    function nvDrawer() { return document.querySelector('cart-drawer'); }

    function nvDrawerSections() {
      var d = nvDrawer();
      if (d && typeof d.getSectionsToRender === 'function') {
        return d.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      }
      return 'cart-drawer,cart-icon-bubble';
    }

    var nvAdding = false;

    function nvAddToCart() {
      if (!form || nvAdding) return;
      nvAdding = true;

      var btns = [].slice.call(form.querySelectorAll('[data-nv-cta]'))
        .concat([].slice.call(document.querySelectorAll('[data-nv-cta-sticky]')));
      btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });

      var body = new FormData(form);
      body.append('sections', nvDrawerSections());
      body.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, data: j }; });
        })
        .then(function (res) {
          if (!res.ok || res.data.status) throw res.data;
          var d = nvDrawer();
          /* renderContents repaints the drawer and opens it. */
          if (d && typeof d.renderContents === 'function' && res.data.sections) {
            d.renderContents(res.data);
            /* Dawn clears is-empty from .drawer__inner but not from the
               <cart-drawer> host, which Liquid stamped when the cart was still
               empty. Left on, the drawer opens looking empty even though the
               line item is right there in the DOM. */
            d.classList.remove('is-empty');
            var inner = d.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');
            return;
          }
          if (d && typeof d.open === 'function') { d.open(); return; }
          /* Last resort only: no drawer in this theme's cart settings. */
          window.location.href = '/cart';
        })
        .catch(function () { window.location.href = '/cart'; })
        .then(function () {
          nvAdding = false;
          btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); nvAddToCart(); });
    }

    /* Inline add-to-cart buttons anywhere on the page route through the same
       handler as the main button, so they add the currently selected tier and
       variant rather than guessing at one. */
    document.querySelectorAll('[data-nv-cta-inline]').forEach(function (btn) {
      if (btn.dataset.nvInlineBound) return;
      btn.dataset.nvInlineBound = '1';
      btn.addEventListener('click', function () { nvAddToCart(); });
    });

    /* Desktop reveal for the sticky bar: watch the real add-to-cart and show
       the bar once it has scrolled up out of view, hiding it again on the way
       back. Mobile shows the bar unconditionally via CSS, so toggling the class
       there is harmless. */
    /* Publish the sticky bar's real height so anything that has to sit above it
       (the FAQ launcher) can clear it at any width. A fixed offset breaks as
       soon as the bar wraps to two lines on a narrow screen. */
    function nvPublishStickyHeight() {
      var bar = document.querySelector('.nv-sticky');
      if (!bar) return;
      var visible = getComputedStyle(bar).display !== 'none';
      var h = visible ? Math.round(bar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--nv-sticky-h', h + 'px');
    }
    nvPublishStickyHeight();
    window.addEventListener('resize', nvPublishStickyHeight);
    if (window.ResizeObserver) {
      var nvBarEl = document.querySelector('.nv-sticky');
      if (nvBarEl) new ResizeObserver(nvPublishStickyHeight).observe(nvBarEl);
    }

    var stickyBar = document.querySelector('[data-nv-sticky]');
    var mainCta = form ? form.querySelector('[data-nv-cta]') : null;
    if (stickyBar && mainCta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', scrolledPast);
        nvPublishStickyHeight();
      }, { threshold: 0 }).observe(mainCta);
    }

    var sticky = document.querySelector('[data-nv-sticky]');
    if (sticky && form) {
      sticky.querySelectorAll('[data-nv-cta-sticky]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          nvAddToCart();
        });
      });
    }

    render();

    /* Position the gallery for the variant we LOAD with, not only the one that
       gets clicked. Landing straight on a size (a ?variant= link, a collection
       card, the size overlay) previously left slide 0 on screen while the buy
       box showed a different pack, so a 600g selection still showed the 280g
       pouch. 'auto' because a smooth scroll on first paint reads as a glitch. */
    if (state.variant && typeof state.variant.mediaIndex === 'number' && state.variant.mediaIndex > 0) {
      goToSlide(state.variant.mediaIndex, 'auto');
    }
  }


  /* ──────────────────────────────────────────────────────────────────────
     Reviews anchor.

     The rating line links to #nv-reviews, but no element with that id is on
     the page: nv-social-proof carries it and is disabled on most PDP
     templates, so the reviews that DO render come from the Judge.me app
     section. The link therefore did nothing on every product.

     Resolve the target at CLICK time rather than inserting an anchor. An
     earlier attempt added <div id="nv-reviews"> and it computed to
     display:none, because app CSS hides stray children of #MainContent.

     behavior:'auto', not 'smooth'. A smooth scroll on this page moves 0px
     over 3.5s — something in the app stack cancels it — so it must match
     native anchor behaviour.
     ────────────────────────────────────────────────────────────────────── */
  function reviewsTarget() {
    var section = function (el) {
      return el && el.closest ? el.closest('[id^="shopify-section-"]') : null;
    };
    return (
      document.getElementById('nv-reviews') ||
      document.querySelector('[id$="__reviews_app"]') ||
      section(document.getElementById('judgeme_product_reviews')) ||
      section(document.querySelector('.jdgm-rev-widg, .jdgm-widget, [data-oke-widget]'))
    );
  }

  function scrollToReviews() {
    var t = reviewsTarget();
    if (!t) return false;
    var top = t.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'auto' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#nv-reviews"], a[href$="#nv-reviews"]');
    if (!a) return;
    if (scrollToReviews()) e.preventDefault();
    /* If nothing resolved, let the browser do whatever it would have done
       rather than swallowing the click. */
  });

  /* Someone arriving on .../#nv-reviews gets the same treatment. The widget
     is injected by the app, so retry briefly before giving up. */
  function honourHashOnLoad() {
    if (location.hash !== '#nv-reviews') return;
    var n = 0;
    var iv = setInterval(function () {
      if (scrollToReviews() || ++n > 20) clearInterval(iv);
    }, 150);
  }
  document.addEventListener('DOMContentLoaded', honourHashOnLoad);
  if (document.readyState !== 'loading') honourHashOnLoad();

  function boot() {
    document.querySelectorAll('[data-nv-pdp]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState !== 'loading') boot();
})();
